import {DialogManager} from '@modifi/plugin-dialogs'

import AccountSetupCompleteDialog, {
  DIALOG_NAME as ACCOUNT_SETUP_COMPLETE_DIALOG,
} from './account-setup-complete'

DialogManager.addDialog(ACCOUNT_SETUP_COMPLETE_DIALOG, AccountSetupCompleteDialog)

export {ACCOUNT_SETUP_COMPLETE_DIALOG}
